import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from "@/core/service/room.baseapi.service";

class RoomInfoService extends RoomBaseApiService {
    constructor() {
        super()
    }
    async getRoomInfo(roomId) {
        try {
            const response = await this.request().get(`/api/v3/room/${roomId ? roomId : this.getRoomId()}/info`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const roomInfoService = new RoomInfoService()